import {
  GetIFDefinitionsRequest,
  GetIFDefinitionsResponse,
  GetIFDefinitionHistoryRequest,
  GetIFDefinitionHistoryResponse,
  GetIfDefinitionForReferenceRequest,
  GetIfDefinitionForReferenceResponse,
  UpdateIFDefinitionsRequest,
  UpdateIFDefinitionsResponse,
  UpdateIFDefinitionsGodRequest,
  UpdateIFDefinitionsGodResponse,
  GetIfDefinitionCommonValidationResultRequest,
  GetIfDefinitionCommonValidationResultResponse,
  GetIfDefinitionReviewDiffsRequest,
  GetIfDefinitionReviewDiffsResponse,
  IfDefinitionReportRequest,
} from ".";
import {
  restResourceDownloader,
  restResourceRequester,
} from "../rest-resource-requester";
import { stringify } from "../../util/querystring-util";

interface IfDefinitionsRestResource {
  getIfDefinitions(
    request: GetIFDefinitionsRequest,
  ): Promise<GetIFDefinitionsResponse>;
  getIFDefinitionHistory(
    request: GetIFDefinitionHistoryRequest,
  ): Promise<GetIFDefinitionHistoryResponse>;
  getIfDefinitionForReference(
    request: GetIfDefinitionForReferenceRequest,
  ): Promise<GetIfDefinitionForReferenceResponse>;
  updateIfDefinitions(
    request: UpdateIFDefinitionsRequest,
  ): Promise<UpdateIFDefinitionsResponse>;
  updateIfDefinitionsGod(
    request: UpdateIFDefinitionsGodRequest,
  ): Promise<UpdateIFDefinitionsGodResponse>;
  getIfDefinitionCommonValidationResult(
    request: GetIfDefinitionCommonValidationResultRequest,
  ): Promise<GetIfDefinitionCommonValidationResultResponse>;
  getIfDefinitionReviewDiffs(
    request: GetIfDefinitionReviewDiffsRequest,
  ): Promise<GetIfDefinitionReviewDiffsResponse>;
  ifDefinitionReport(request: IfDefinitionReportRequest): void;
}

const REST_RESOURCE_NAME = {
  IF_DEFINITIONS: "/if-definitions",
  IF_DEFINITIONS_HISTORY: "/if-definitions/history",
  IF_DEFINITIONS_REFERENCE: "/if-definitions/reference",
  IF_DEFINITIONS_GOD: "/if-definitions/god",
  IF_DEFINITIONS_VALIDATION: "/if-definitions/validation",
  IF_DEFINITIONS_REVIEW_DIFFS: "/if-definitions/review-diffs",
};

/**
 * POST /get-if-definitions
 */
const getIfDefinitions = restResourceRequester<
  GetIFDefinitionsRequest,
  GetIFDefinitionsResponse
>(
  "POST",
  (_) => `${REST_RESOURCE_NAME.IF_DEFINITIONS}`,
  (request) => JSON.stringify(request),
);

/**
 * GET /get-if-definition-history
 */
const getIFDefinitionHistory = restResourceRequester<
  GetIFDefinitionHistoryRequest,
  GetIFDefinitionHistoryResponse
>("GET", (request) => {
  const queryParameters = {
    dfnSetVerNum: request.dfnSetVerNum,
    srcInbdId: request.srcInbdId,
    dstOtbdId: request.dstOtbdId,
    isPrd: request.isPrd,
  };
  return `${REST_RESOURCE_NAME.IF_DEFINITIONS_HISTORY}?${stringify(
    queryParameters,
  )}`;
});

/**
 * POST /if-definitions/reference
 */
const getIfDefinitionForReference = restResourceRequester<
  GetIfDefinitionForReferenceRequest,
  GetIfDefinitionForReferenceResponse
>(
  "POST",
  (_) => `${REST_RESOURCE_NAME.IF_DEFINITIONS_REFERENCE}`,
  (request) => JSON.stringify(request),
);

/**
 * PUT /update-if-definitions
 */
const updateIfDefinitions = restResourceRequester<
  UpdateIFDefinitionsRequest,
  UpdateIFDefinitionsResponse
>(
  "PUT",
  (_) => `${REST_RESOURCE_NAME.IF_DEFINITIONS}`,
  (request) => JSON.stringify(request),
);

/**
 * PUT /update-if-definitions-god
 */
const updateIfDefinitionsGod = restResourceRequester<
  UpdateIFDefinitionsGodRequest,
  UpdateIFDefinitionsGodResponse
>(
  "PUT",
  (_) => `${REST_RESOURCE_NAME.IF_DEFINITIONS_GOD}`,
  (request) => JSON.stringify(request),
);

/**
 * GET /if-definitions/validation
 */
const getIfDefinitionCommonValidationResult = restResourceRequester<
  GetIfDefinitionCommonValidationResultRequest,
  GetIfDefinitionCommonValidationResultResponse
>("GET", (request) => {
  const queryParameters = {
    dfnSetVerNum: request.dfnSetVerNum,
    validationTypeCode: request.validationTypeCode,
    pjtId: request.pjtId,
  };
  return `${REST_RESOURCE_NAME.IF_DEFINITIONS_VALIDATION}?${stringify(
    queryParameters,
  )}`;
});

/**
 * POST /if-definitions/review-diffs
 */
const getIfDefinitionReviewDiffs = restResourceRequester<
  GetIfDefinitionReviewDiffsRequest,
  GetIfDefinitionReviewDiffsResponse
>(
  "POST",
  (_) => `${REST_RESOURCE_NAME.IF_DEFINITIONS_REVIEW_DIFFS}`,
  (request) => JSON.stringify(request),
);

/**
 * POST /if-definitions/{type}/report
 */
const ifDefinitionReport = restResourceDownloader<IfDefinitionReportRequest>(
  "POST",
  (request) => `${REST_RESOURCE_NAME.IF_DEFINITIONS}/${request.type}/report`,
  (request) => JSON.stringify(request),
);

export const interfaceListRestResource: IfDefinitionsRestResource = {
  getIfDefinitions: getIfDefinitions,
  getIFDefinitionHistory: getIFDefinitionHistory,
  getIfDefinitionForReference: getIfDefinitionForReference,
  updateIfDefinitions: updateIfDefinitions,
  updateIfDefinitionsGod: updateIfDefinitionsGod,
  getIfDefinitionCommonValidationResult: getIfDefinitionCommonValidationResult,
  ifDefinitionReport: ifDefinitionReport,
  getIfDefinitionReviewDiffs: getIfDefinitionReviewDiffs,
};
